import { SvgIcon, Typography } from "@mui/material";

import { WavesIcon } from "lucide-react";
import { useTranslation } from "react-i18next";

import { NightReportMetric } from "interfaces/nightReport.interface";

import { MetricBadge } from "../../../../../NightReportScreen/components/MetricBadge";
import { MovementText } from "../components/MovementText";
import { StatCard } from "../components/StatCard";

type MovementCardProps = {
  movement: number;
  movementMetric: NightReportMetric | null;
};

export function MovementCard({ movement, movementMetric }: MovementCardProps) {
  const { t } = useTranslation();

  return (
    <StatCard>
      <SvgIcon component={WavesIcon} color={"neutral.decoration"} />
      <Typography
        variant={"bodySmallMedium"}
        sx={{
          color: "neutral.subtle",
        }}
      >
        {t("Movement")}
      </Typography>
      <Typography variant={"headingLargeRegular"}>
        <MovementText movement={movement} />
      </Typography>
      {movementMetric?.deviation_pct && (
        <MetricBadge
          showPercent
          metric={movementMetric}
          alertMetric={"time_asleep"}
          delta={movementMetric.deviation_pct}
          sx={{ alignSelf: "self-start" }}
        />
      )}
    </StatCard>
  );
}
